import LoggingService from "@/services/LoggingService.ts"

// Key must match the inline recorder script in index.html — that script can't import from src/.
const STORAGE_KEY = "nexus-asset-load-failure"

export default {
  reportIfPresent(): void {
    let raw: string | null
    try {
      raw = sessionStorage.getItem(STORAGE_KEY)
    } catch {
      return
    }
    if (!raw) return

    try {
      sessionStorage.removeItem(STORAGE_KEY)
    } catch {
      // best effort
    }

    try {
      const { url, timestamp } = JSON.parse(raw)
      LoggingService.log(
        "asset_load_failure_recovered",
        { failedUrl: url, failedAt: timestamp },
        "warn",
      )
    } catch {
      // malformed payload — nothing useful to log
    }
  },
}
